/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Empty_RoundInputs */



/**
* | output |
* | --- |
* | "A round must keep at least one table — cancel the round instead." |
*
* @param {Err_Tournament_Empty_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_empty_round = /** @type {((inputs?: Err_Tournament_Empty_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Empty_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une ronde doit conserver au moins une table — annulez plutôt la ronde.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una ronda debe conservar al menos una mesa — cancele la ronda en su lugar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma rodada deve manter ao menos uma mesa — cancele a rodada em vez disso.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un round deve mantenere almeno un tavolo — annulla piuttosto il round.")
	return /** @type {LocalizedString} */ ("A round must keep at least one table — cancel the round instead.")
});